<template>
  <div class="home">
    <!-- <el-dialog
      title="请选择语言类型"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <el-radio v-model="radio" label="chinese">中文</el-radio>
      <el-radio v-model="radio" label="english">英文</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog> -->
    <div class="title">
      <img src="static/img/logo.png" class="logo">
      <span class="logoName">NASELIT</span>
      <!-- <el-select v-model="searchValue" filterable placeholder="请选择" class="choose" filterable clearable @change="selectChangePage">
        <el-option
          v-for="item in search"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select> -->
      <div class="changeLanguage" @click="selectLanguage">
          {{language}}
      </div>
      <div class="nav" @mouseleave="leaveMenu">
        <div class="navBlock" v-for="(item,index) in navList" :key="index" @mouseenter="enterMenu(index)" @click="changePages(index)">
          <span class="navClick">{{item.name}}</span>
          <div class="navMore" v-if="item.children && index==selected">
            <div class="navMoreBlock" @click="goPages(index)" v-for="(child,index) in item.children" :key="index" :class="index==hoverIndex?'navMoreHover':''" @mouseenter="erterNavBlock(index)" @mouseleave="leaveBlock">
              {{child.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
        <router-view style="animation-duration: 0.3s"/>
    </div>
    <div class="foot">
      <!-- <div class="footLeft"> -->
        <div class="aboutNslt">
          <div class="footBlockTitle">
            <span>{{this.$store.state.language.r}}</span>
          </div>
          <div class="aboutNsltList" v-for="(item,index) in aboutNsltList" :key="index" @click="navigateTo(index,item)">
            {{item.name}}
          </div>
        </div>
        <div class="information">
          <div class="footBlockTitle">
            <span class="infSpan">{{this.$store.state.language.s}}</span>
          </div>
          <div class="informationList" v-for="(item,index) in informationList" :key="index" @click="navigateTo(index,item)">
            {{item.name}}
          </div>
        </div>
        <div class="service">
          <div class="footBlockTitle">
            <span class="serviceSpan">{{this.$store.state.language.t}}</span>
          </div>
          <div class="serviceList" v-for="(item,index) in serviceList" :key="index" @click="navigateTo(index,item)">
            {{item.name}}
          </div>
        </div>
        <a class="webNumber" target="_blank" href="http://www.beian.miit.gov.cn/">
          沪ICP备19044284号-1
        </a>
        <img src="static/img/tip.png" class="tip">
        <a class="policeNumber" target="_blank" href="http://www.beian.miit.gov.cn/">沪公网安备 31011502015163号</a>
      <!-- </div> -->
      <div class="footRight">
        <div class="footRightTop">
          <img src="static/img/logo.png" class="footLogo">
          <span class="footLogoName">NASELIT</span>
          <img src="static/img/site.png" class="siteIMg">
          <p class="siteDes">{{this.$store.state.language.q}}</p>
          <img src="static/img/email.png" class="emailIMg">
          <p class="emailDes">info@naselit.com</p>
        </div>
        <div class="footRightBottom">

        </div>
      </div>
    </div>

    
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
     return{
      //  navList:[{name:'网站首页'},{name:'关于NASELIT'},{name:'产品中心',children:[{name:'M170'},{name:'M220'},{name:'MUTA软件系统'},{name:'微测'}]},{name:'应用方案',children:[{name:'5G基站测试方案'},{name:'OTA话务量测试方案'}]},{name:'招贤纳士'},{name:'联系我们'}],
       navList:this.$store.state.language.m,
       searchValue: '',
       search: [{label:'网站首页',value:'1'},{label:'M170',value:'2'},{label:'M220',value:'3'},{label:'MUTA软件系统',value:'4'},
       {label:'微测',value:'5'},{label:'5G基站测试方案',value:'6'},{label:'OTA话务量测试方案',value:'7'},{label:'招贤纳士',value:'8'},
       {label:'关于NASELIT',value:'9'}],
       language: 'En',
       centerDialogVisible: false,
       radio:'chinese',
       selected: '',
       hoverIndex: -1,
       aboutNsltList:this.$store.state.language.n,
       informationList:this.$store.state.language.o,
       serviceList:this.$store.state.language.p,
       change:'product',
       chinese:{a:'测试'},
       english:{a:'test'},
       transitionName:'slide-left'
     }
  },
  methods: {
    selectLanguage: function(){
      // this.centerDialogVisible = true;
      if(this.language == "中文"){
        this.language = "En";
        this.$store.commit('chinese')
      }else{
        this.language = "中文";
        this.$store.commit('english');
      }
    },
    confirm: function(){
      console.log(this.radio);
      if(this.radio == "chinese"){
        this.language = "中文";
        this.$store.commit('chinese')
      }else{
        this.language = "英文";
        this.$store.commit('english');
      }
      this.centerDialogVisible = false;
    },
    enterMenu: function(index){
      console.log(index)
      this.selected = index;
      if(index == 1){
        this.change = 'product';
      }else if(index == 2){
        this.change = 'application';
      }
    },
    changePages: function(index){
      if(index == 0){
        this.$router.push({path:'/'});
      }
      // else if(index == 1){
      //   this.$router.push({path:'AboutNaselit'});
      // }
      else if(index == 3){
        this.$router.push({path:'recruit'});
      }else if(index == 4){
        this.$router.push({path:'AboutNaselit'});
      }
    },
    leaveMenu: function(){
      this.selected = "";
    },
    erterNavBlock: function(index){
      this.hoverIndex = index;
    },
    leaveBlock: function(){
      this.hoverIndex = -1;
    },
    goPages: function(index){
      console.log(index);
      if(this.change == 'product'){
        if(index == 0){
        this.$router.push({path:'/m170'});
      }else if(index == 1){
        this.$router.push({path:'/m220'});
      }else if(index == 2){
        this.$router.push({path:'/mutaSystem'});
      }else if(index == 3){
        this.$router.push({path:'/wc'});
      }else if(index == 4){
        this.$router.push({path:'/CNSimulator'});
      }
      }else{
        if(index == 0){
        this.$router.push({path:'/5gTest'});
      }else if(index == 1){
        this.$router.push({path:'/ota'});
      }
      }
    },
    selectChangePage: function(item){
      console.log(item)
      if(item == 1){
        this.$router.push({path:'/'});
      }else if(item == 2){
        this.$router.push({path:'/m170'});
      }else if(item == 3){
        this.$router.push({path:'/m220'});
      }else if(item == 4){
        this.$router.push({path:'/mutaSystem'});
      }else if(item == 5){
        this.$router.push({path:'/wc'});
      }else if(item == 6){
        this.$router.push({path:'/5gTest'});
      }else if(item == 7){
        this.$router.push({path:'/ota'});
      }else if(item == 8){
        this.$router.push({path:'/recruit'});
      }else if(item == 9){
        this.$router.push({path:'/AboutNaselit'});
      }
    },
    navigateTo: function(index,item){
      console.log(index);
      console.log(item)
      if(item.name == "Company" || item.name == "公司信息"){
        this.$router.push({path:'/AboutNaselit'});
      }else if(item.name == "Career" || item.name == "工作"){
        this.$router.push({path:'/recruit'});
      }
    }
  },
  mounted: function(){
    var storage=window.localStorage;
    // this.$store.commit('add');
    // console.log(this.$store.state.count);
    // console.log(this.$store.getters.getStateCount);
    // this.$store.commit('english')
    // console.log(this.$store.state);
  },
  watch:{
    $route (to, from) {
      console.log(to);
      console.log(from);
    },
    '$store.state.language.m'(val){
      this.navList = val
    },
    '$store.state.language.n'(val){
      this.aboutNsltList = val
    },
    '$store.state.language.o'(val){
      this.informationList = val
    },
    '$store.state.language.p'(val){
      this.serviceList = val
    },
  }
}
</script>

<style scoped>
.home{
  width:100%;
  height:100%;
}
.title{
  width: 100%;
  height: 110px;
  background-color: rgba(0, 133, 213, 0.95);
  position: relative;
}
.nav{
  width: 50%;
  height: 40px;
  position: absolute;
  top: 70px;
  left: 12%
}
.foot{
  width: 100%;
  height: 270px;
  background-color: #202020;
  position: relative
}
.logo{
  width: 65px;
  height: 65px;
  margin-left: calc(12% - 10px);
}
.navBlock{
  width: 16.6%;
  height: 100%;
  float: left;
  line-height: 40px;
  color: white;
  font-size: 0.9rem;
  text-align: center;
  position: relative;
  z-index: 999
}
.navBlock:nth-child(1){
  text-align: left;
  width: calc(16.6% - 1.2rem)
}
.navClick{
  cursor: pointer
}
.logoName{
  font-size: 30px;
  color: white;
  position: absolute;
  left: calc(12% + 70px);
  top: 14px;
}
.choose{
  position: absolute;
  right: 100px;
  top: 23px;
}
.changeLanguage{
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 1rem;
  color: white;
  cursor: pointer;
}
.footRight{
  width: 500px;
  height: 100%;
  float: right
}
.footRightTop{
  width: 100%;
  height: 190px;
  border-left: 2px dashed #808080;
  margin-top: 40px;
  position: relative;
  box-sizing: border-box
}
.footLogo{
  width: 50px;
  height: 50px;
  position: absolute;
  left: 30px;
}
.footLogoName{
  position: absolute;
  font-size: 20px;
  color: white;
  left: 90px;
  top: 10px;
}
.navMore{
  width: 100%;
  border: 1px solid rgb(241, 241, 241);
  border-radius: 10px;
  background-color: white;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.4);
}
.navBlock:nth-child(1) .navMore{
  position: absolute;
  left: -0.65rem
}
.navMoreHover{
  background-color: rgb(235,236,240);
  color: white;
  cursor: pointer;
}
.navMoreBlock{
  width: 100%;
  min-height: 40px;
  color: black;
  border-radius: 10px;
}
.footLeft{
  width: calc(100% - 500px);
  height: 100%;
  background-color: saddlebrown;
  float: left;
  position: relative;
}
.aboutNslt{
  width: 9rem;
  height: 230px;
  position: absolute;
  top: 35px;
  left: 12%;
  overflow: hidden;
}
.information{
  width: 8rem;
  height: 230px;
  position: absolute;
  top: 35px;
  left: calc(12% + 9rem);
}
.service{
  width: 7rem;
  height: 230px;
  position: absolute;
  top: 35px;
  left: calc(12% + 18rem)
}
.footBlockTitle{
  width: 120%;
  height: 33px;
  color:#aaaaaa;
  text-align: center;
  line-height: 33px;
  font-size: 0.8rem;
  margin-bottom: 15px;
}
.footBlockTitle span{
  display: block;
  width:fit-content!important;
  width:-webkit-fit-content!important;
  width:-moz-fit-content!important;
  height: 30px;
  border-bottom: 2px solid #CFCFCF;
}
.infSpan{
  width: 3.3rem!important
}
.serviceSpan{
  width: 4rem!important
}
.aboutNsltList,.informationList,.serviceList{
  width: 100%;
  height: 22px;
  line-height: 22px;
  font-size: 0.8rem;
  color: white;
  cursor: pointer;
}
.siteIMg{
  width: 25px;
  height: 25px;
  position: absolute;
  left: 35px;
  top: 60px;
}
.emailIMg{
  position: absolute;
  width: 28px;
  height: 28px;
  left: 33px;
  top: 110px
}
.emailDes{
  position: absolute;
  width: 400px;
  height: 25px;
  font-size: 14px;
  color: #B2B2B2;
  left: 70px;
  top: 110px;
  line-height: 25px
}
.siteDes{
  position: absolute;
  width: 400px;
  height: 25px;
  font-size: 14px;
  color: #B2B2B2;
  left: 70px;
  top: 60px;
  line-height: 25px
}
.webNumber{
  color: #B2B2B2;
  width: 200px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  position: absolute;
  left: 12%;
  bottom: 0;
  font-size: 12px;
  text-decoration: none;
}
.policeNumber{
  color: #B2B2B2;
  width: 300px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  position: absolute;
  left: calc(12% + 200px);
  bottom: 0;
  font-size: 12px;
  text-decoration: none;
}
.tip{
  position: absolute;
  bottom: 5px;
  left: calc(12% + 175px);
}
.content{
  width: 100%;
  /* min-height: 800px; */
  min-height: calc(100% - 380px);
  overflow: auto;
  /* position: relative */
}
</style>



// WEBPACK FOOTER //
// src/App.vue